export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9031.458ec5ae.jpg";